import React from 'react';

interface PepperRatingProps {
  value: number;
}

export function PepperRating({ value }: PepperRatingProps) {
  return (
    <div className="rl-rating-badge" aria-label={`Rating ${value.toFixed(1)} out of 5`}>
      <i className="fa fa-star rl-rating-badge-icon" aria-hidden />
      {value.toFixed(1)}
    </div>
  );
}
